import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IMeterHistory } from "Shared/Types/meter-history";
import {
  addMeterHistory,
  getMeterHistory,
  getMeterHistorysList,
} from "./reducer";

interface BlockTypeSliceState {
  error?: string | null;
  loading: boolean;
  success?: boolean | null;
  meterHistoryList: IMeterHistory[];
  currentMeterHistory: IMeterHistory | null;
  numPage: number;
  isFuncLoading: boolean;
}

const initialState: BlockTypeSliceState = {
  loading: false,
  error: null,
  meterHistoryList: [],
  currentMeterHistory: null,
  numPage: 0,
  isFuncLoading: false,
};

const meterHistorySlice = createSlice({
  name: "meterHistorySlice",
  initialState,
  reducers: {
    clear(state) {
      state.error = null;
      state.loading = false;
      state.success = null;
    },
    clearCurrentMeterHistory(state) {
      state.currentMeterHistory = null;
    },
  },
  extraReducers: (builder) => {
     builder.addCase(getMeterHistorysList.pending, (state, action) => {
       state.loading = true;
     });
     builder.addCase(getMeterHistorysList.fulfilled, (state, action) => {
       state.loading = false;
       state.error = null;
       state.meterHistoryList = action.payload.results;
       state.numPage = action.payload.count;
     });
     builder.addCase(getMeterHistorysList.rejected, (state, action) => {
       state.loading = false;
     });
    builder.addCase(getMeterHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.currentMeterHistory = action.payload;
    });
    builder.addCase(addMeterHistory.pending, (state) => {
      state.isFuncLoading = true;
      state.error = null;
      state.success = false;
    });

    builder.addCase(addMeterHistory.fulfilled, (state) => {
      state.isFuncLoading = false;
      state.error = null;
      state.success = true;
    });

    builder.addCase(addMeterHistory.rejected, (state, action) => {
      state.isFuncLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { clear, clearCurrentMeterHistory } = meterHistorySlice.actions;

export const selectMeterHistorysList = (state: RootState) =>
  state.meterHistory.meterHistoryList;

export const selectMeterHistorysIsFuncLoading = (state: RootState) =>
  state.meterHistory.isFuncLoading;
export const selectMeterHistorysNumPage = (state: RootState): number =>
  state.meterHistory.numPage;
export const selectCurrentMeterHistory = (state: RootState) =>
  state.meterHistory.currentMeterHistory;
export const selectMeterHistoryLoading = (state: RootState) =>
  state.meterHistory.loading;
export const selectMeterHistoryError = (state: RootState) =>
  state.meterHistory.error;
export const selectMeterHistorySuccess = (state: RootState) =>
  state.meterHistory.success;

export default meterHistorySlice;
